













































import { Prop, Vue } from "vue-property-decorator";
import { Component } from "vue-mixin-decorator";
import { ServerTestResult } from "@/@types/socket";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import { TargetVersion } from "@/app/core/api/Github";

@Component({ components: {} })
export default class VersionInfoComponent extends Vue {
  @Prop({ type: Object, required: true })
  private serverTestResult!: ServerTestResult;

  private clientVersion: string = process.env.VUE_APP_VERSION!;
  private serverVersion: string | null = null;
  private usable: boolean = false;
  private targetServer: TargetVersion | null = null;
  private targetClient: TargetVersion | null = null;

  @LifeCycle
  public async mounted() {
    this.serverVersion = this.serverTestResult.serverVersion.replace(
      "Quoridorn ",
      ""
    );
    this.usable = this.serverTestResult.usable;
    this.targetServer = this.serverTestResult.targetServer;
    this.targetClient = this.serverTestResult.targetClient;
  }
}
